import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'followAiMateButton'
	| 'stopGeneratingButtonLabel'
	| 'thinkingText'
	| 'thinkingTextShort'
	| 'editingText'
	| 'editingTextShort'
	| 'thinkingReadyMessage'
	| 'thinkingClose'
	| 'thinkingReadyView'
	| 'thinkingErrorMessage'
	| 'thinkingErrorTryAgain';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		followAiMateButton: {
			id: 'ai-mate.inline-chat-input.follow-button.label',
			defaultMessage: 'Follow',
			description: 'Label for the follow AI mate button',
		},
		stopGeneratingButtonLabel: {
			id: 'ai-mate.inline-chat-input.stop-generating-button.label',
			defaultMessage: 'Stop generating',
			description: 'Label for the stop generating button',
		},
		thinkingText: {
			id: 'ai-mate.inline-chat-input.thinking',
			defaultMessage: 'Rovo is analyzing',
			description: 'Text displayed when the assistant is processing a request.',
		},
		thinkingTextShort: {
			id: 'ai-mate.inline-chat-input.thinking.short',
			defaultMessage: 'Analyzing',
			description:
				'Shortened text displayed when the assistant is processing a request in chromeless/inline comment contexts.',
		},
		editingText: {
			id: 'ai-mate.inline-chat-input.editing',
			defaultMessage: 'Rovo is editing',
			description: 'Text displayed when the assistant is editing a request.',
		},
		editingTextShort: {
			id: 'ai-mate.inline-chat-input.editing.short',
			defaultMessage: 'Editing',
			description:
				'Shortened text displayed when the assistant is editing a request in chromeless/inline comment contexts.',
		},
		thinkingReadyMessage: {
			id: 'ai-mate.thinking-bar.ready.message',
			defaultMessage: 'Your edits are ready',
			description: 'Default text shown in the thinking ready bar.',
		},
		thinkingClose: {
			id: 'ai-mate.thinking-bar.close',
			defaultMessage: 'Close',
			description: 'Label for the close action in the thinking bar.',
		},
		thinkingReadyView: {
			id: 'ai-mate.thinking-bar.ready.view',
			defaultMessage: 'View',
			description: 'Label for the view button in the thinking ready bar.',
		},
		thinkingErrorMessage: {
			id: 'ai-mate.thinking-bar.error.message',
			defaultMessage: 'An unknown error occurred.',
			description:
				'Default text shown in the thinking error bar when no specific message is provided.',
		},
		thinkingErrorTryAgain: {
			id: 'ai-mate.thinking-bar.error.try-again',
			defaultMessage: 'Try again',
			description: 'Label for the try again button in the thinking error bar.',
		},
	});

export default message;
